<script setup>
import moment from "moment";
import "vue-select/dist/vue-select.css";
import {computed, onMounted, reactive, ref, watch} from "vue";
import {useRoute} from "vue-router";
import FTDropdownSelect from "../../../shared/compat/FTDropdownSelect.vue";
import FTDatePicker from "../../../shared/compat/FTDatePicker.vue";

const props = defineProps(["tasks", "defaults"]);

const downloadCsv = ref([]);
const showDownloads = ref(false);
const trees = ref(null);
const offset = ref(3);
const pagination = ref({});
const loading = ref(true);
const options = ref(props.defaults);
const selSpecies = ref(null);
const showMore = ref(false);
const showMap = ref(false);
const processType = ref(null);
const groupByDate = ref(false);
const groupByUser = ref(false);
const createdBetween = ref({start: null, end: null});

const queryDate = ref(null);
const queryType = ref(null);

const selectedWorks = ref([]);

const emits = defineEmits(["emit-filter"]);
const route = useRoute();

const formattedFilter = computed(() => {
  return {
    works: selectedWorks.value.length ? selectedWorks.value : null,
    createdBetween: createdBetween.value,
  };
});

const emitFilter = () => {
  emits("emit-filter", formattedFilter.value);
};

watch([createdBetween, selectedWorks], emitFilter, {deep:true});

onMounted(() => {
  queryDate.value = route.query.date;
  queryType.value = route.query.type;

  if (queryDate.value && queryType.value) {
    groupByDate.value = false;
    groupByUser.value = false;
    if (queryType === "stumps") {
      filter.works_id = [13];
    }
  }
});

const handleResetDate = () => {
  createdBetween.value = {start: null, end: null};
};

const handleUpdateCreatedBetween = (value) => {
    if(!value || value.length !== 2) {
        createdBetween.value = {start: null, end: null};
        return;
    }
  const parseDate = (string) => moment(string).format('YYYY-MM-DD')
  createdBetween.value['start'] = parseDate(value[0])
  createdBetween.value['end'] = parseDate(value[1])
}
const textInputFormat = {
    format: "dd/MM/yyyy - dd/MM/yyyy ",
};
</script>
<template>
  <div>
    <div class="w-full">
      <!--     Filter bar container       -->
      <div
        class="w-full flex flex-wrap justify-center lg:flex-no-wrap lg px-8 pb-4"
      >
        <!--    first date filter    -->
        <div class="w-full xl:w-1/3 p-4 h-auto">
          <p class="text-md text-slate-600">Dates Between</p>
            <VueDatePicker
                :text-input="textInputFormat"
                mode="range"
                v-model="createdBetween"
                :format="'dd/MM/yyyy'"
                :range="true"
                :enable-time-picker="false"
                :multi-calendars="2"
                :auto-apply="true"
                @update:modelValue="handleUpdateCreatedBetween"
            />

          <div
            class="text-slate-600 hover:text-blue-600 cursor-pointer text-sm mt-1"
            @click="handleResetDate"
          >
            Reset date
          </div>
        </div>
        <!--        2nd filter tasks        -->
        <div class="w-full xl:w-1/3 p-4" v-if="tasks">
          <p class="text-md text-slate-600">Work Completed</p>
          <FTDropdownSelect
            label="task"
            class="style-chooser"
            multiple
            :options="tasks"
            v-model="selectedWorks"
            :reduce="(type) => type.id"
                            />

        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ol-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 200px;
}

.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}

.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}

.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}

.ol-popup-closer:after {
  content: "\274c";
}
.date-selected-input {
  background: #ffffff;
  border: 1px solid #cbd5e0;
  color: #394066;
  border-radius: 4px;
}
:deep(.dp__input) {
    border: 1px solid #cbd5e0 !important;
    color: #394066 !important;
    border-radius: 4px;
    padding-top: 10px;
    padding-bottom: 10px;

}
</style>
